module.exports = __webpack_public_path__ + "img/report.a67bd128.png";